import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { productosPath } from 'src/app/shared/helpers/constants';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { SeguroPrivadoResumenComponent } from './pages/seguro-privado-resumen/seguro-privado-resumen.component';
import { SeguroPrivadoDetalleComponent } from './pages/seguro-privado-detalle/seguro-privado-detalle.component';
import { SeguroPrivadoMainComponent } from './pages/seguro-privado-main/seguro-privado-main.component';
import { PolizaGuard } from 'src/app/shared/guards/poliza.guard';
import { PageView, getValuePageView } from 'src/app/shared/enums/insights/page-view';

const routes: Routes = [
  {
    path: '',
    redirectTo: productosPath.children.privado.children.resumen.path,
    pathMatch: 'full',
  },
  {
    path: productosPath.children.privado.children.resumen.path,
    component: SeguroPrivadoResumenComponent,
    canActivate: [AuthGuard],
    data: {
      viewName: PageView.privateInsuranceSummaryView,
      label: getValuePageView[PageView.privateInsuranceSummaryView]
    }
  },
  {
    path: productosPath.children.privado.children.detalle.path,
    component: SeguroPrivadoDetalleComponent,
    canActivate: [AuthGuard, PolizaGuard],
    children: [
      {
        path: '',
        component: SeguroPrivadoMainComponent,
        data: {
          viewName: PageView.privateInsuranceDetailView,
          label: getValuePageView[PageView.privateInsuranceDetailView]
        }
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SeguroPrivadoRoutingModule {}
